import { fetchApi } from "@/services/api"
import { mockProVenueInstanceService } from "@/mocks/provenue-instance-service"
import type { CreateProVenueInstanceRequest, ProVenueConfigType, SharedProVenueInstance, UpdateProVenueInstanceRequest } from "@/types/provenue-instance"

function publicInstance(instance: unknown): SharedProVenueInstance {
  if (typeof instance !== "object" || instance === null) {
    throw new Error("Unexpected ProVenue instance response")
  }
  const { id, name, hostName } = instance as Partial<SharedProVenueInstance>
  if (!Number.isSafeInteger(id) || typeof id !== "number" || id < 1 || typeof name !== "string" || typeof hostName !== "string") {
    throw new Error("Unexpected ProVenue instance response")
  }
  return { id, name, hostName }
}

const endpoint = "/api/v1/config/provenue-instances"
const realProVenueInstanceService = {
  async getAll(configType?: ProVenueConfigType): Promise<SharedProVenueInstance[]> {
    const response = await fetchApi<unknown>(configType ? `${endpoint}?${new URLSearchParams({ configType })}` : endpoint)
    if (!Array.isArray(response)) throw new Error("Unexpected ProVenue instance list response")
    return response.map(publicInstance)
  },
  async create(data: CreateProVenueInstanceRequest): Promise<SharedProVenueInstance> {
    const response = await fetchApi<unknown>(endpoint, {
      method: "POST",
      body: JSON.stringify({ ...data, name: data.name.trim(), hostName: data.hostName.trim() }),
    })
    return publicInstance(response)
  },
  async update(id: number, data: UpdateProVenueInstanceRequest): Promise<SharedProVenueInstance> {
    const response = await fetchApi<unknown>(`${endpoint}/${id}`, {
      method: "PUT",
      body: JSON.stringify({
        name: data.name.trim(), hostName: data.hostName.trim(),
        ...(data.consumerKey?.trim() ? { consumerKey: data.consumerKey } : {}),
        ...(data.consumerSecret?.trim() ? { consumerSecret: data.consumerSecret } : {}),
      }),
    })
    return publicInstance(response)
  },
  async delete(id: number): Promise<void> {
    return fetchApi<void>(`${endpoint}/${id}`, { method: "DELETE" })
  },
}

export const proVenueInstanceService = import.meta.env.VITE_USE_MOCKS === "true"
  ? mockProVenueInstanceService
  : realProVenueInstanceService
